import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { IoMdInformationCircleOutline } from 'react-icons/io'
import { IoWarningOutline } from 'react-icons/io5'

const getIconName = (type) => {
  if (type === 'info') {
    return <IoMdInformationCircleOutline size={24} className="mr-2 text-blue-500 flex-shrink-0" />
  }
  if (type === 'warning') {
    return <IoWarningOutline size={24} className="mr-2 text-yellow-500 flex-shrink-0" />
  }
  return <IoMdInformationCircleOutline size={24} className="mr-2 text-blue-500 flex-shrink-0" />
}
const getLeftBorderType = (type) => {
  if (type === 'info') {
    return 'border-blue-500'
  }
  if (type === 'warning') {
    return 'border-yellow-500'
  }
  return 'border-blue-500'
}

const Hint = ({ type, children }) => (
  <div className={classNames('my-4 p-4 bg-secondary rounded border-l-4 flex', getLeftBorderType(type))}>
    {getIconName(type)}
    <p>{children}</p>
  </div>
)

Hint.propTypes = {
  type: PropTypes.oneOf(['info', 'warning']),
}

Hint.defaultProps = {
  type: 'info',
}

export default Hint
